import { render, staticRenderFns } from "./Households.vue?vue&type=template&id=db2b7f0e&"
import script from "./Households.vue?vue&type=script&lang=js&"
export * from "./Households.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db2b7f0e')) {
      api.createRecord('db2b7f0e', component.options)
    } else {
      api.reload('db2b7f0e', component.options)
    }
    module.hot.accept("./Households.vue?vue&type=template&id=db2b7f0e&", function () {
      api.rerender('db2b7f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/household/Households.vue"
export default component.exports